var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { PaymentTarget } from '../payment-target.enum.js';
import { PaymentType } from '../payment-type.enum.js';
export class PaymentResponseDto {
    id;
    createdAt;
    updatedAt;
    target;
    officeProductId;
    type;
    preventionCourseId;
    userId;
    connectedStripeAccountId;
    stripeAccountId;
    stripeCheckoutSessionId;
    stripePaymentIntentId;
    preventionVoucherId;
    rawData;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PaymentResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PaymentResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PaymentResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsEnum(PaymentTarget),
    Expose(),
    __metadata("design:type", String)
], PaymentResponseDto.prototype, "target", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "officeProductId", void 0);
__decorate([
    IsEnum(PaymentType),
    Expose(),
    __metadata("design:type", String)
], PaymentResponseDto.prototype, "type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "preventionCourseId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PaymentResponseDto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "stripeAccountId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "stripeCheckoutSessionId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "stripePaymentIntentId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "preventionVoucherId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], PaymentResponseDto.prototype, "rawData", void 0);
//# sourceMappingURL=payment.response.dto.js.map